import Component from './platform-button.component';

export { Component };

export default Component;
